import { apiClient } from "../config/axios";
import { storage } from "../storage/storage";

export interface CreateSessionPayload {
    userAgent: string;
    clientId: string;
}

export interface Session {
    id: string;
    createdAt: string;
}

export const sessionService = {
    async create(payload: CreateSessionPayload, apiKey?: string, embedOrigin?: string): Promise<Session> {
        const headers: Record<string, string> = {};
        if (apiKey) headers["x-api-key"] = apiKey;
        if (embedOrigin) headers["x-embed-origin"] = embedOrigin;
        const { data } = await apiClient.post<Session>("/v1/sessions", payload, { headers });
        storage.set("sessionId", data.id);
        return data;
    },

    getStoredSessionId(): string | null {
        return storage.get<string>("sessionId");
    },
};
